import React from 'react';
import {documentTypes} from '../../../../util/uiconstants';

/**
 * Special config key for observers that should be mounted by the host on
 * every Ares document, regardless of the current documentTypeId. Observers
 * declared under this key stack on top of any documentTypeId-specific entry.
 */
export const DEFAULT_OBSERVERS_KEY = 'default';

/**
 * Lazy registry of observers to mount per Ares document type. Each entry is
 * a React.lazy component that owns its own slice selection, watched fields
 * and host-notification contract. Keeping entries lazy ensures observers
 * for document types not visited in the current session never enter the
 * initial bundle - only the chunk for the active document type is fetched.
 *
 * Two flavors of entries:
 *  - [DEFAULT_OBSERVERS_KEY]: observers instantiated by default on every
 *    Ares document. Use for cross-document concerns.
 *  - [documentTypes.XYZ]: observers only instantiated when the active
 *    document has that documentTypeId.
 *
 * Add a new observer by:
 *  1. Creating a component under ./Observers that uses CanvasFormObserver
 *     as a primitive and encapsulates its own onChange contract;
 *  2. Adding a React.lazy entry under the relevant key here. The `name`
 *     must be unique across the whole registry (used as the React key).
 */
export const OBSERVERS_CONFIG_BY_DOCUMENT_TYPE = {
	[DEFAULT_OBSERVERS_KEY]: [],
	[documentTypes.GUIDEDWORKFLOWV2]: [
		{
			name: 'materiality',
			component: React.lazy(() => import(/* webpackChunkName: "observer-materiality" */ './Observers/MaterialityObserver'))
		}
	]
};
